import { AssetClass } from "types/AssetClass";
import { YieldList } from "types/YieldList";
import { createCustomAction } from "typesafe-actions";

const YIELDLIST_DATA_LOAD = "YIELDLIST/YIELDLIST_DATA_LOAD";
const YIELDLIST_DATA_LOAD_SUCCESS = "YIELDLIST/YIELDLIST_DATA_LOAD_SUCCESS";
const YIELDLIST_DATA_LOAD_FAIL = "YIELDLIST/YIELDLIST_DATA_LOAD_FAIL";

export type YieldListContentType = "all" | keyof typeof AssetClass;

export const load = createCustomAction(
  YIELDLIST_DATA_LOAD,
  (type) => (contentType: YieldListContentType) => ({
    type,
    contentType,
  })
);

export const loadSuccess = createCustomAction(
  YIELDLIST_DATA_LOAD_SUCCESS,
  (type) => (contentType: YieldListContentType, data?: YieldList[]) => ({
    type,
    contentType,
    data,
  })
);

export const loadFail = createCustomAction(
  YIELDLIST_DATA_LOAD_FAIL,
  (type) => (contentType: YieldListContentType, error?: string) => ({
    type,
    contentType,
    error,
  })
);
